import React, { useEffect, useState } from 'react';
import { getData } from '../global/Globalapi';

const ProductImageGallery = ({ productId }) => {
  const [images, setImages] = useState([]);

  useEffect(() => {
    getData(`/images/${productId}`)
      .then((res) => {
        setImages(res.data);
      })
      .catch((err) => {
        console.error('Error fetching images:', err);
      });
  }, [productId]);

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 p-4">
      {images.map((img) => (
        <div key={img.image_id} className="bg-white shadow rounded p-2">
          <img
            src={`/uploads/${img.file_name}`}
            alt={img.description}
            className="w-full h-40 object-cover rounded"
          />
          <div className="mt-2 text-center">
            <p className="text-sm text-gray-700">{img.description}</p>
            <p className="text-xs text-gray-500">Order: {img.display_order}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ProductImageGallery;
